export interface CostBreakupColumn {
  key: string;
  label: string;
  summable?: boolean;
}

export const COST_BREAKUP_FIELD_LABELS: CostBreakupColumn[] = [
  { key: 'UsageAccountId', label: 'Account ID' },
  { key: 'AccountID', label: 'Account ID' },
  { key: 'ResourceId', label: 'Instance ID' },
  { key: 'RegionName', label: 'Region' },
  { key: 'InstanceType', label: 'Instance Type' },
  { key: 'MarketOption', label: 'Pricing Type' },
  { key: 'OperatingSystem', label: 'Operating System' },
  { key: 'quantity', label: 'Quantity (Hrs)' },
  { key: 'totalcost', label: 'Total Cost' },
  { key: 'DeploymentOption', label: 'Availability' },
  { key: 'DatabaseEngine', label: 'DB Engine' },
  { key: 'DataProcessed_Quantity_GB', label: 'Quantity (GB)' },
  { key: 'DataProcessed_Cost', label: 'Cost' },
  { key: 'Storage_Quantity_GB_Mo', label: 'Quantity (GB-Mo)' },
  { key: 'Storage_Cost', label: 'Cost' },
  { key: 'Vended_Quantity_GB', label: 'Quantity (GB)' },
  { key: 'Vended_Cost', label: 'Cost' },
  { key: 'Total_Cost', label: 'Total Cost' },
  { key: 'Metrics Cost', label: 'Cost' },
  { key: 'S3DataEventsQty', label: 'Quantity (Events)' },
  { key: 'S3DataEventsCost', label: 'Cost' },
  { key: 'EventsAnalyzedQty', label: 'Quantity (Events)' },
  { key: 'EventsAnalyzedCost', label: 'Cost' },
  { key: 'EventsAnalyzedBytesQty', label: 'Quantity (GB)' },
  { key: 'EventsAnalyzedBytesCost', label: 'Cost' },
  { key: 'OthersCost', label: 'Cost' },
  { key: 'TotalCost', label: 'Total Cost' },
  { key: 'interAZQuantity', label: 'Quantity (GB)' },
  { key: 'interAZCost', label: 'Cost' },
  { key: 'internetOutQuantity', label: 'Quantity (Events)' },
  { key: 'quantity_requests', label: 'Quantity (Requests)' },
  { key: 'cost', label: 'Cost' },
  { key: 'Other_Cost', label: 'Other Cost' },
  { key: 'TotalUsageAmount', label: 'Total Requests' },
  { key: 'ServiceCategory', label: 'Service Category' },
  { key: 'ResourcePath', label: 'Resource Path' }
];

export const INSTANCE_COST_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  EC2: ['quantity', 'totalcost'],
  RDS: ['quantity', 'totalcost'],
  ElastiCache: ['quantity', 'totalcost'],
  OpenSearch: ['quantity', 'totalcost'],
  Redshift: ['quantity', 'totalcost'],
};

export const CLOUDWATCH_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  'CloudWatch Logs': [
    'DataProcessed_Quantity_GB',
    'DataProcessed_Cost',
    'Storage_Quantity_GB_Mo',
    'Storage_Cost',
    'Vended_Quantity_GB',
    'Vended_Cost',
    'Total_Cost',
  ],
  'CloudWatch Metrics': [
    'Quantity (Metrics)',
    'Metrics Cost'
  ],
};

export const ANALYTICS_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  Kinesis: ['TotalCost'],
};

export const MEDIASERVICES_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  MediaLive: ['TotalCost', 'TotalUsageAmount'],
};

export const CONTAINER_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  EKS: ['Total Cost', 'Other_Cost', 'Cost', 'Quantity(Hours)'],
  ECR: ['Total Cost',  'Storage_Quantity_GB_Mo', 'Storage_Cost'],
  ECS: ['Total Cost', 'Other_Cost', 'Cost', 'Quantity(Hours)'],
};

export const NETWORK_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  'API Gateway': ['TotalUsageAmount', 'TotalCost'],
  Cloudfront: ['TotalUsageAmount', 'TotalCost'],
};

export const GROUPS = {
  Storage: ['Storage_Quantity_GB_Mo', 'Storage_Cost'],
  'Data Processed': ['DataProcessed_Quantity_GB', 'DataProcessed_Cost'],
  Vended: ['Vended_Quantity_GB', 'Vended_Cost'],
  'Metric API Calls': ['Quantity (Metrics)', 'Metrics Cost'],
  'S3 Data Events Analyzed': ['S3DataEventsQty', 'S3DataEventsCost'],
  'Events Analyzed': ['EventsAnalyzedQty', 'EventsAnalyzedCost'],
  'Events Analyzed bytes': [
    'EventsAnalyzedBytesQty',
    'EventsAnalyzedBytesCost',
  ],
  Others: ['OthersCost'],
  'Inter AZ': ['interAZQuantity', 'interAZCost'],
  'Internet Out': ['internetOutQuantity', 'internetOutCost'],
  'Region To Region': ['regionToRegionQuantity', 'regionToRegionCost'],
  Requests: ['quantity_requests', 'cost'],
  'Running Hrs': ['Quantity(Hours)', 'Cost'],
};

export const STORAGE_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  S3: ['Standard API', 'Standard Storage', 'Other', 'totalcost'],
  'EBS Snapshot': ['totalcost'],
  'EBS Volumes': ['Quantity(GB-Mo)', 'totalcost'],
  EFS: ['Quantity(GB-Mo)', 'Cost', 'totalcost'],
};

export const SECURITY_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  GuardDuty: [
    'S3DataEventsQty',
    'S3DataEventsCost',
    'EventsAnalyzedQty',
    'EventsAnalyzedCost',
    'EventsAnalyzedBytesQty',
    'EventsAnalyzedBytesCost',
    'OthersCost',
    'totalcost',
  ],
  WAF: [
    'S3DataEventsQty',
    'S3DataEventsCost',
    'EventsAnalyzedQty',
    'EventsAnalyzedCost',
    'EventsAnalyzedBytesQty',
    'EventsAnalyzedBytesCost',
    'OthersCost',
    'totalcost',
  ],
};

export const DATA_TRANSFER_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  'Elastic Compute Cloud': [],
  'ELastic Load Balancing': [],
  'Simple Storage Service': [],
};

export const SERVERLESS_SUMMABLE_COLUMNS_BY_TAB: Record<string, string[]> = {
  SQS: ['quantity_requests', 'cost', 'totalcost'],
  LAMBDA: ['quantity_requests', 'cost', 'totalcost'],
  SES: ['quantity_requests', 'cost', 'totalcost'],
};